"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.then = exports.unit = void 0;
exports.unit = {};
const then = (f, g) => (x) => g(f(x));
exports.then = then;
